import { Card, CardContent, useTheme } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/system";
import React from "react";

interface OnboardingCardProps {
  children: React.ReactNode;
}

export const OnboardingCard: React.FC<OnboardingCardProps> = ({ children }) => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      id="onboarding-form"
      raised
      sx={{
        boxShadow: "rgba(0, 0, 0, 0.12) 0px 12px 40px 0px",
        width: sm ? "100vw" : "400px",
        height: "max-content",
        minHeight: sm ? "100vh" : undefined,
        maxWidth: "100vw",
        backgroundColor: sm ? theme.surface.lowest : undefined,
        display: sm ? "flex" : undefined,
        justifyContent: sm ? "center" : undefined
      }}
    >
      <CardContent
        sx={{
          maxWidth: "450px",
          backgroundColor: (theme: Theme) => theme.surface.lowest,
          borderRadius: sm ? "0" : "8px",
          padding: "40px !important"
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};
